import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthSsoService {
  env = environment;

  constructor(
    private http: HttpClient,
  ) { }

  validateUser(): Observable<any> {
    const url = environment.apiUrl + `/users/me`;
    return this.http.get(url, { observe: 'response', withCredentials: true }).pipe(
      map((res: any) => res.body ?? null),
    );
  }

}
